import React from 'react';

const ReminderIcon = () => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
      <path
        opacity="0.4"
        d="M17 0.333333C8.17808 0.333333 1 7.51141 1 16.3333C1 25.1553 8.17808 32.3333 17 32.3333C25.8219 32.3333 33 25.1553 33 16.3333C33 7.51141 25.8219 0.333333 17 0.333333ZM17 29.3333C10.0962 29.3333 4.66667 23.9038 4.66667 16.9999C4.66667 10.0962 10.0962 4.66667 17 4.66667C23.9038 4.66667 29.3333 10.0962 29.3333 16.9999C29.3333 23.9038 23.9038 29.3333 17 29.3333Z"
        fill="currentColor"
      />
      <path
        d="M17 9C16.3242 9 15.6667 9.52571 15.6667 10.2V17.8C15.6667 18.4743 16.3242 19 17 19C17.6758 19 18.3333 18.4743 18.3333 17.8V10.2C18.3333 9.52571 17.6758 9 17 9ZM17 22.6667C16.0833 22.6667 15.3333 23.4167 15.3333 24.3333C15.3333 25.25 16.0833 26 17 26C17.9167 26 18.6667 25.25 18.6667 24.3333C18.6667 23.4167 17.9167 22.6667 17 22.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ReminderIcon;
